module.exports = __webpack_public_path__ + "static/christina-yacht-6-5795134c0a342d3d653802cfc393ec4a.jpg";